import { personInfoAddressFrag } from '../../../../utils/type/person.common-type';

export const clientsWaitingListFrag = `
    id
    folderId
    folder {
        id
        serviceId
        personId
        person {
            ${personInfoAddressFrag}
        }
    }
    dateFrom
    dateTo
    removalReason
    offerId
    offer {
        id
        code
        name
        unit
        color
    }
    applications
    operations
    procedures
`;

export const attendantsWaitingListFrag = `
    id
    folderId
    folder {
        id
        serviceId
        personId
        person {
            ${personInfoAddressFrag}
        }
    }
    entryDate
    dateTo
    removalReason
    readyToUseService
    note
    ratingPoints
    form
    files
`;
